import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=261e0249&scoped=true&"
import script from "./Articles.vue?vue&type=script&lang=ts&"
export * from "./Articles.vue?vue&type=script&lang=ts&"
import style0 from "./Articles.vue?vue&type=style&index=0&id=261e0249&lang=scss&scoped=true&"
import style1 from "./Articles.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261e0249",
  null
  
)

export default component.exports